import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TablePagesTitle from "../../../components/table-pages-title/TablePagesTitle";
import AccessPageAction from "../page-action/AccessPageAction";
import "./../accessmanagement.scss";
import { buttonName, roleMange } from "../../../locales/en";
import { useCreateRole } from "../../../hooks/useCreateRole";
import { ROLE } from "../../../route/paths";
import {
  getPermissionAccessOptions,
  getTwoFactorOptions
} from "../../../utils/getDropdownOptions";
import { isRadioGroupNavItem } from "../../../utils/roleUtils";
import CreateRoleSkeleton from "../../../components/skeletons/CreateRoleSkeleton";

const CreateRole = () => {
  const history = useNavigate();
  const [filteredMenuPermissions, setFilteredMenuPermissions] = useState([]);
  const {
    loading,
    roleName,
    permissionType,
    adminMenuPermissions,
    orderNumber,
    errOrderMessage,
    isTwoFactorEnabled,
    roleNameError,
    checkedItems,
    roleNameRef,
    permissionAccessRef,
    orderNumberRef,
    handleRoleNameChange,
    handleTfaChange,
    handleShortChange,
    handlePermissionTypeChange,
    handleSelectAll,
    handleChildChange,
    handleSubmit,
    resetForm
  } = useCreateRole({
    onSuccess: () => history(ROLE)
  });

  const onCancel = () => {
    resetForm();
    history(ROLE);
  };

  useEffect(() => {
    if (adminMenuPermissions !== null) {
      const filterVisibleNavItems = adminMenuPermissions
        ?.filter((item) => item.isActive)
        .map((item) => ({
          ...item,
          children: item.children?.filter((child) => child.isActive) || []
        }));
      setFilteredMenuPermissions(filterVisibleNavItems);
    }
  }, [adminMenuPermissions]);

  return (
    <>
      <TablePagesTitle
        mainTitle="Access Management"
        content="Role Management"
      />
      <AccessPageAction
        subheading="Create Role"
        alluser="/admin/access/role"
        allUserTitle="All Roles"
        createuser="/admin/access/role/create"
        createUserTitle="Create Role"
      />

      {loading ? (
        <CreateRoleSkeleton />
      ) : (
        <div className="row mb-3 mx-0">
          <div className="col-md-12 sale-leade-form mt-3">
            <form onSubmit={handleSubmit}>
              <div className="row mb-2">
                <div className="col-sm-4 col-xl-2">
                  <div className="input-title">
                    <label>{roleMange.label1}</label>
                  </div>
                </div>
                <div className="col-sm-8 col-xl-10">
                  <div className="input-group">
                    <input
                      ref={roleNameRef}
                      type="text"
                      placeholder="Role Name"
                      name="name"
                      maxLength={30}
                      onChange={handleRoleNameChange}
                      value={roleName}
                    />
                  </div>
                  {roleNameError && (
                    <div className="text-danger small">{roleNameError}</div>
                  )}
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-sm-4 col-xl-2">
                  <div className="input-title">
                    <label>{roleMange.label2}</label>
                  </div>
                </div>
                <div className="col-sm-8 col-xl-10">
                  <div className="input-group">
                    <select
                      name="isTwoFactorEnabled"
                      id="isTwoFactorEnabled"
                      onChange={handleTfaChange}
                      value={String(isTwoFactorEnabled)}
                    >
                      {getTwoFactorOptions().map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-sm-4 col-xl-2">
                  <div className="input-title">
                    <label>{roleMange.label3}</label>
                  </div>
                </div>
                <div className="col-sm-8 col-xl-10">
                  <div className="input-group">
                    <input
                      ref={orderNumberRef}
                      type="number"
                      min={1}
                      name="orderNumber"
                      onChange={handleShortChange}
                      value={orderNumber}
                    />
                  </div>
                  {errOrderMessage && (
                    <div className="text-danger small">{errOrderMessage}</div>
                  )}
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-sm-4 col-xl-2">
                  <div className="input-title">
                    <label>{roleMange.label4}</label>
                  </div>
                </div>
                <div className="col-sm-8 col-xl-10">
                  <div className="input-group">
                    <select
                      ref={permissionAccessRef}
                      name="fullAccess"
                      id="fullAccess"
                      onChange={handlePermissionTypeChange}
                      value={String(permissionType)}
                    >
                      {getPermissionAccessOptions().map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              {permissionType === false && (
                <div className="row mb-2">
                  <div className="col-sm-4 col-xl-2">
                    <div className="input-title">
                      <label>{roleMange.label6}</label>
                    </div>
                  </div>
                  <div className="col-sm-8 col-xl-10">
                    <div className="border p-3">
                      {filteredMenuPermissions?.map((item) => (
                        <div key={item.id} className="mb-3 permission-group">
                          <div className="mb-2">
                            <div className="input-title">
                              <label
                                className={
                                  isRadioGroupNavItem(item.slugName)
                                    ? ""
                                    : "cursor-pointer"
                                }
                              >
                                {!isRadioGroupNavItem(item.slugName) && (
                                  <input
                                    type="checkbox"
                                    className="me-1 select-all"
                                    checked={checkedItems[item.id] || false}
                                    onChange={(e) =>
                                      handleSelectAll(item.id, e.target.checked)
                                    }
                                  />
                                )}
                                {item.name}
                              </label>
                            </div>
                          </div>
                          {item.children && item.children.length > 0 && (
                            <div className="row permissions-list">
                              {item.children.map((child) => (
                                <div
                                  className="col-lg-6 col-xl-4"
                                  key={child.id}
                                >
                                  <input
                                    type={
                                      isRadioGroupNavItem(item.slugName)
                                        ? "radio"
                                        : "checkbox"
                                    }
                                    id={`menu-${child.id}`}
                                    name={
                                      isRadioGroupNavItem(item.slugName)
                                        ? `menu-group-${item.id}`
                                        : undefined
                                    }
                                    checked={checkedItems[child.id] || false}
                                    onChange={(e) =>
                                      handleChildChange(
                                        item.id,
                                        child.id,
                                        e.target.checked
                                      )
                                    }
                                  />
                                  <label
                                    htmlFor={`menu-${child.id}`}
                                    className="ms-1 cursor-pointer"
                                  >
                                    {child.name}
                                  </label>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              <div className="row mt-4">
                <div className="col-sm-8 offset-sm-2 d-flex d-sm-block justify-content-center justify-content-sm-start">
                  <button
                    type="button"
                    className="btn btn-red me-2"
                    onClick={onCancel}
                  >
                    {buttonName.cancel}
                  </button>
                  <button type="submit" className="btn btn-primary">
                    {buttonName.create}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default CreateRole;
